import React from 'react'
import Paginated from '@orionx-dev/meteor-paginated-graphql-react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import formatCurrency from 'App/helpers/formatCurrency'
import { MdAlarm } from 'react-icons/md'
import OrderDetails from 'App/components/OrderDetails'
import styles from './styles.css'

export default class Orders extends React.Component {
  static propTypes = {
    code: PropTypes.string,
  }

  @autobind
  renderPrice(order) {
    const { market } = order
    const { secondaryCurrency } = market
    if (order.type === 'market') {
      return 'Mercado'
    }
    return <span>{formatCurrency(order.limitPrice, secondaryCurrency, { code: true })}</span>
  }

  @autobind
  renderType(order) {
    const action = order.sell ? 'Venta' : 'Compra'
    const stop = order.isStop ? <MdAlarm /> : null
    return (
      <span>
        <span>{action}</span> {stop}
      </span>
    )
  }

  @autobind
  renderAmount(order) {
    const { market } = order
    const { mainCurrency, secondaryCurrency } = market
    return order.secondaryAmount
      ? formatCurrency(order.secondaryAmount, secondaryCurrency, { code: true })
      : formatCurrency(order.amount || 0, mainCurrency, { code: true })
  }

  @autobind
  renderFilled(order) {
    if (order.status === 'stop') return '-'
    const { market } = order
    const { mainCurrency, secondaryCurrency } = market
    return order.secondaryAmount
      ? formatCurrency(order.secondaryFilled, secondaryCurrency, { code: true })
      : formatCurrency(order.filled, mainCurrency, { code: true })
  }

  getFields() {
    return [
      {
        title: 'Mercado',
        name: 'market.code',
      },
      {
        title: 'Tipo',
        name: 'type',
        render: this.renderType,
      },
      {
        title: 'Precio',
        name: 'limitPrice',
        render: this.renderPrice,
      },
      {
        title: 'Monto',
        name: 'amount',
        render: this.renderAmount,
      },
      {
        title: 'Completado',
        name: 'filled',
        render: this.renderFilled,
      },
      {
        title: 'Estado',
        name: 'status',
      },
    ]
  }

  @autobind
  onSelect(order) {
    this.details.open(order._id)
  }

  render() {
    return (
      <div className="table w-full mt-3">
        <div className={styles.table}>
          <Paginated
            headTitle="Órdenes"
            queryName="orders"
            fields={this.getFields()}
            onPress={this.onSelect}
            params="$currencyCode: ID, $filter: String"
            currencyCode={this.props.code}
            extraFields={[
              'market.mainCurrency.units',
              'market.mainCurrency.format',
              'market.mainCurrency.code',
              'market.secondaryCurrency.units',
              'market.secondaryCurrency.format',
              'market.secondaryCurrency.code',
              'secondaryAmount',
              'secondaryFilled',
              'sell',
            ]}
          />
          <OrderDetails setRef={details => (this.details = details)} />
        </div>
      </div>
    )
  }
}
